import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchUserAccount = async (userId, implementationId) => {
    return apiWrapper({
      fetch,
      url: `accounts/user?userId=${userId}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchUserAccount
  }
}